import { Box, HStack, IconButton, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { CalendarPlus, Plus } from "../../../shared/icons";
import { DIAS_SEMANA_ABREV } from "../../../shared/lib/date";
import { eventsOnDate, parseIsoDate } from "../utils/calendarViews";
import ShiftRow from "./ShiftRow";
import CalendarEventRow from "./CalendarEventRow";

const shortDate = (iso) => {
  const [, month, day] = iso.split("-");
  return `${day}/${month}`;
};

// Visão Semana: 7 colunas de domingo a sábado (no celular, um dia embaixo do outro). Cada
// dia lista os plantões que começam nele — o noturno não se repete no dia seguinte — e os
// compromissos que o ocupam, com as mesmas ações do popover do Mês.
export default function WeekView({ dates, today, shiftsByDate, events, vinculosById, shiftActions, onEditEvent, onDeleteEvent, onRegister, onAddEvent }) {
  return (
    <SimpleGrid columns={{ base: 1, xl: 7 }} spacing={2}>
      {dates.map((date) => {
        const shifts = shiftsByDate[date] ?? [];
        const dayEvents = eventsOnDate(events, date);
        const isToday = date === today;
        const label = `${DIAS_SEMANA_ABREV[parseIsoDate(date).getDay()]} ${shortDate(date)}`;
        return (
          <Box
            key={date}
            as="section"
            aria-label={label}
            border="1px solid"
            borderColor={isToday ? "primary" : "app-border"}
            borderWidth={isToday ? "2px" : "1px"}
            borderRadius="md"
            p={2}
            minW={0}
            minH={{ xl: "180px" }}
          >
            <HStack justify="space-between" mb={2} spacing={1}>
              <Text fontSize="xs" fontWeight={isToday ? "bold" : "semibold"} color={isToday ? "accent-text" : "app-muted-fg"}>
                {label}
              </Text>
              <HStack spacing={0}>
                <IconButton
                  aria-label={`Registrar plantão em ${shortDate(date)}`}
                  icon={<Plus size={14} />}
                  size="xs"
                  variant="ghost"
                  onClick={() => onRegister(date)}
                />
                <IconButton
                  aria-label={`Adicionar compromisso em ${shortDate(date)}`}
                  icon={<CalendarPlus size={14} />}
                  size="xs"
                  variant="ghost"
                  onClick={() => onAddEvent(date)}
                />
              </HStack>
            </HStack>
            <VStack align="stretch" spacing={3}>
              {shifts.map((shift) => (
                <ShiftRow key={shift.id} shift={shift} vinculo={vinculosById[shift.vinculo_id]} actions={shiftActions} compact />
              ))}
              {dayEvents.map((event) => (
                <CalendarEventRow key={`compromisso-${event.id}`} event={event} onEdit={onEditEvent} onDelete={onDeleteEvent} />
              ))}
              {shifts.length === 0 && dayEvents.length === 0 ? (
                <Text fontSize="xs" color="app-muted-fg">
                  Livre
                </Text>
              ) : null}
            </VStack>
          </Box>
        );
      })}
    </SimpleGrid>
  );
}
